import { Network, Split, Cpu, Workflow } from "lucide-react";
import Reveal from "@/components/Reveal";
import { OFFERINGS } from "@/lib/site";

const ICONS = { Network, Workflow, Split, Cpu };

export default function WhatIDo() {
  return (
    <section id="what-i-do" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.3em] text-fog">01 // WHAT I DO</p>
        <h2 className="mt-6 max-w-2xl font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
          Four ways I plug into your stack.
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-16">
        <div className="grid grid-cols-1 border-l border-t border-white/10 md:grid-cols-2">
          {OFFERINGS.map(({ n, icon, title, desc, tags }) => {
            const Icon = ICONS[icon];
            return (
              <div
                key={n}
                data-testid={`offering-${n}`}
                className="group border-b border-r border-white/10 p-8 transition-colors duration-300 hover:bg-white/[0.03] lg:p-12"
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs text-fog transition-colors group-hover:text-accent">{n}</span>
                  <Icon className="h-5 w-5 text-fog transition-colors group-hover:text-white" strokeWidth={1.5} />
                </div>
                <h3 className="mt-10 font-display text-2xl font-bold tracking-tight text-white">{title}</h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-fog">{desc}</p>
                <div className="mt-8 flex flex-wrap gap-2">
                  {tags.map((t) => (
                    <span
                      key={t}
                      className="border border-white/15 px-3 py-1 font-mono text-[10px] tracking-[0.15em] text-white/60"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}
